import { FC, ReactNode } from "react";
import { InputBaseProps } from ".";

interface props extends InputBaseProps {
  children: ReactNode;
}

export const InputContainer: FC<props> = (props) => {
  return (
    <div>
      {!!props.label && (
        <div className="text-gray-400 text-xs font-normal mb-1">
          {props.label}
          {!!props.required && <span className="ms-1.5 text-error">*</span>}
        </div>
      )}
      {props.children}
      {props.errorMessage && <div>{props.errorMessage}</div>}
    </div>
  );
};
